import hexRgb from 'hex-rgb';

export default ({ color, alpha = 1 }) => hexRgb(color, { format: 'css', alpha });
